import { McpAccessScope } from '../../../store/McpAccess';

export const SCOPE_LABELS: Record<McpAccessScope, string> = {
  read_only: 'Read only',
  read_write: 'Read & write'
};
